<div class="flex flex-col gap-6 max-w-md p-1">
  <!-- En-tête de la modale -->
  <div class="flex items-start justify-between gap-4">
    <div class="flex flex-col gap-1">
      <div class="flex items-center gap-2">
        <span class="w-2.5 h-2.5 rounded-full bg-primary-9"></span>
        <span class="text-xs font-semibold uppercase tracking-wider text-neutral-11"> Configuration </span>
      </div>
      <h3 class="text-xl font-bold tracking-tight text-neutral-12 m-0">Paramètres de l'agenda</h3>
    </div>

    <button
      type="button"
      mat-icon-button
      (click)="dialogRef.close()"
      aria-label="Fermer"
      class="text-neutral-10 hover:text-neutral-12 hover:bg-neutral-3 rounded-md"
    >
      <mat-icon class="!text-xl !w-5 !h-5 flex items-center justify-center">close</mat-icon>
    </button>
  </div>

  <!-- Corps des réglages -->
  <div class="flex flex-col gap-5">
    <div
      class="text-xs font-semibold uppercase tracking-wider text-neutral-11 border-b border-neutral-4 pb-2"
    >
      Options d'affichage
    </div>

    <!-- Option 1 : Afficher les week-ends -->
    <div
      class="flex items-center justify-between gap-4 p-3 bg-neutral-2/50 border border-neutral-4 rounded-xl"
    >
      <div class="flex flex-col gap-0.5">
        <span class="text-sm font-medium text-neutral-12">Afficher les week-ends</span>
        <span class="text-xs text-neutral-10">
          Affiche le samedi et le dimanche dans les vues mois et semaine
        </span>
      </div>
      <mat-slide-toggle
        color="primary"
        [checked]="showWeekends()"
        (change)="showWeekends.set($event.checked)"
        aria-label="Afficher les week-ends"
      />
    </div>

    <!-- Option 2 : Premier jour de la semaine -->
    <div class="flex flex-col gap-2 p-3 bg-neutral-2/50 border border-neutral-4 rounded-xl">
      <div class="flex flex-col gap-0.5">
        <span class="text-sm font-medium text-neutral-12">Premier jour de la semaine</span>
        <span class="text-xs text-neutral-10">
          Définit le premier jour affiché dans la semaine et la grille mensuelle
        </span>
      </div>

      <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-full mt-1">
        <mat-select
          [value]="firstDayOfWeek()"
          (selectionChange)="firstDayOfWeek.set($event.value)"
          aria-label="Premier jour de la semaine"
        >
          <mat-option [value]="1" #optMonday [class]="optMonday.selected ? 'text-white' : 'text-neutral-12'">
            Lundi
          </mat-option>
          <mat-option [value]="0" #optSunday [class]="optSunday.selected ? 'text-white' : 'text-neutral-12'">
            Dimanche
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Option 3 : Plage horaire en mode semaine -->
    <div class="flex flex-col gap-2 p-3 bg-neutral-2/50 border border-neutral-4 rounded-xl">
      <div class="flex flex-col gap-0.5">
        <span class="text-sm font-medium text-neutral-12">Plage horaire en mode semaine</span>
        <span class="text-xs text-neutral-10">
          En mode semaine, afficher de telle heure à telle heure par défaut
        </span>
      </div>

      <div class="grid grid-cols-2 gap-3 mt-1">
        <div>
          <span class="block text-xs font-medium text-neutral-11 mb-1">Heure de début</span>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-full">
            <mat-select
              [value]="weekStartHour()"
              (selectionChange)="weekStartHour.set($event.value)"
              aria-label="Heure de début"
            >
              @for (hour of availableStartHours; track hour) {
                <mat-option
                  [value]="hour"
                  #optStart
                  [class]="optStart.selected ? 'text-white' : 'text-neutral-12'"
                >
                  {{ formatHourLabel(hour) }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div>
          <span class="block text-xs font-medium text-neutral-11 mb-1">Heure de fin</span>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-full">
            <mat-select
              [value]="weekEndHour()"
              (selectionChange)="weekEndHour.set($event.value)"
              aria-label="Heure de fin"
            >
              @for (hour of availableEndHours; track hour) {
                <mat-option
                  [value]="hour"
                  #optEnd
                  [class]="optEnd.selected ? 'text-white' : 'text-neutral-12'"
                >
                  {{ formatHourLabel(hour) }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      @if (!isValidHours()) {
        <p class="text-xs text-ruby-11 font-medium mt-1 mb-0">
          L'heure de début doit être antérieure à l'heure de fin.
        </p>
      }
    </div>
  </div>

  <!-- Actions -->
  <div class="flex items-center justify-end gap-3 pt-2 border-t border-neutral-4">
    <button
      type="button"
      mat-button
      (click)="dialogRef.close()"
      class="text-neutral-11 hover:text-neutral-12"
    >
      Annuler
    </button>
    <button type="button" mat-flat-button color="primary" [disabled]="!isValidHours()" (click)="onSave()">
      Enregistrer
    </button>
  </div>
</div>
